export enum Keys {
  USER_FORM = 'RBI:USER_FORM',
  HAS_SHOWN_STORE_CHANGE_DIALOG = 'RBI:HAS_SHOWN_STORE_CHANGE_DIALOG',
}
